import React, { useEffect, useState } from "react";
import { UrlApi } from "../../../services/apirest";
import { getData, postData } from "../../../services/library";
import {
  IconButton,
  Button,
  Stack,
  Grid,
  Tooltip,
  Container,
  TextField,
  Typography,
  Autocomplete,
} from "@mui/material";
import moment from "moment";
import Box from "@mui/material/Box";
import Notify from "../../Notify";
import Title from "../../Title";

import { v4 as uuidv4 } from "uuid";

//Iconos para los textfields
import InputAdornment from "@mui/material/InputAdornment";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

// ICONOS
import TimeToLeaveIcon from "@mui/icons-material/TimeToLeave";
import EightteenMpIcon from "@mui/icons-material/EightteenMp";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import Battery50Icon from "@mui/icons-material/Battery50";
import AddBoxIcon from "@mui/icons-material/AddBox";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import CircularProgress from "@mui/material/CircularProgress";

// COMPONENTES
import AddMarcaVehiculo from "../../vehiculos_nuevo/add/AddMarcaVehiculo";
import AddModeloVehiculo from "../../vehiculos_nuevo/add/AddModeloVehiculo";
import Addchofer from "../choferes/AddChofer";

// Notification
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function Addvehiculos(props) {
  const [uuid, setUuid] = useState(uuidv4());
  console.log("uuid", uuid);
  
  const [disBtn, setDisbtn] = useState(false);

  // ********** AGREGADO DE MARCA Y MODELO ********//
  const [tabla, setTabla] = useState(true);
  const [altaMarca, setAltaMarca] = useState(false);
  const [altaModelo, setAltaModelo] = useState(false);
  const [altachofer, setAltachofer] = useState(false); //Estado para abrir alta chofer
  const [marcas, setMarcas] = useState();
  const [marcaSeleccionada, setMarcaSeleccionada] = useState("");
  const [modelos, setModelos] = useState();
  const [modeloSeleccionado, setModeloSeleccionado] = useState({});
  const [buscando, setBuscando] = useState(false);
  const [actualizar, setActualizar] = useState(false);

  const obtenerMarcas = () => {
    fetch(UrlApi + "/marcas/")
      .then((data) => data.json())
      .then((data) => setMarcas(data));
  };

  useEffect(() => {
    obtenerMarcas();
  }, [tabla]);

  const obtenerModelos = () => {
    setBuscando(true);
    fetch(UrlApi + "/modelos/xmarca/" + marcaSeleccionada.id) //cambiar fetch
      .then((data) => data.json())
      .then((data) => setModelos(data))
      .then((data) => setModeloSeleccionado(""))
      .then((data) => setBuscando(false));
  };

  //funcion que espera los cambios de la funcion de obtener familias
  useEffect(() => {
    obtenerModelos();
  }, [marcaSeleccionada]);

  //agregue este efecto para actualizar el listado de choferes si lo agregan desde addvehiculos
  useEffect(() => {
    if (actualizar) {
      getData("/choferes", setChoferes);
    }
  }, [actualizar]);

  const handleClickMarca = () => {
    setAltaMarca(true);
    setTabla(false);
  };

  const handleClickModelo = (row) => {
    setAltaModelo(true);
    setTabla(false);
  };

  const handleClickchofer = (row) => {
    setAltachofer(true);
    setTabla(false);
  };

  //**********************************************//

  // ---- Notificaciones / snackbar ----
  const [notificacion, setNotificacion] = useState({ tipo: "", mensaje: "" });
  const [openSnack, setOpenSnack] = useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [severity, setSeverity] = useState("success"); // "success" | "error" | "info"
  const [autoHide, setAutoHide] = useState(2000);

  // Colores según estado
  const colorMap = {
    success: "#DFF2D8", // verde
    error: "#F8D7DA", // rojo
    info: "#FFF3CD", // amarillo
  };

  // ---- Cuando cambie `notificacion` abre el snackbar ----
  useEffect(() => {
    if (!notificacion || !notificacion.tipo) return;

    const tipo = notificacion.tipo; // "success" | "error" | "info"
    setMensaje(notificacion.mensaje || "");
    setSeverity(
      tipo === "error" ? "error" : tipo === "info" ? "info" : "success"
    );
    setColorMensaje(colorMap[tipo] || colorMap.info);

    // Si es error, no auto-hide (permanece hasta que el usuario cierre).
    // Si es success, dura 2000ms y cierra el modal (handleClose).
    // Si es info, dura 3000ms.
    if (tipo === "error") setAutoHide(null);
    else if (tipo === "success") setAutoHide(2000);
    else setAutoHide(3000);

    setOpenSnack(true);
  }, [notificacion]);

  // ---- handler para cerrar el snackbar ----
  const handleCloseSnack = (event, reason) => {
    // No cierra por clickaway
    if (reason === "clickaway") return;

    // Si el cierre fue por timeout y fue un success, cierra el componente
    if (reason === "timeout" && severity === "success") {
      setOpenSnack(false);
      setNotificacion({ tipo: "", mensaje: "" });
      // Cerrar el componente
      handleClose();
      return;
    }

    // Para cualquier otro cierre, solo se cierra el snackbar
    setOpenSnack(false);
    setNotificacion({ tipo: "", mensaje: "" });
  };

  //**********************************************//

  const [datosVehiculo, setDatosVehiculo] = useState({
    id_sisven: null,
    id_sisven_autogas:null,
    capacidad: null,
    id_tipo: null,
    activo: 1,
    id_chofer: null,
    tara: null,
    uso: null,
    ltstkcombustible: null,
    id_sucursal: null,
    t1: null,
    marca: null,
    modelo: null,
    patente: null,
    usuario: localStorage.getItem("user"),
    capacidadtotalm3: null,
    duenio: null,
    id_transportista: null,
    id_modelo: null,
    nro_motor: "",
    nro_chasis: "",
    uuid_vehiculo: uuid,
  });

  const [duenio, setduenio] = useState(null);

  //desplegable para tipo vehiculo
  const [choferes, setChoferes] = useState([]);
  const [tipoVehiculo, setTipoVehiculo] = useState([]);
  const [uso, setUso] = useState(null);
  const [sucursales, setSucursales] = useState(null);
  const [transportistas, settransportistas] = useState(null);
  const [choferSeleccionado, setChoferSeleccionado] = useState({});
  const [usoSeleccionado, setUsoSeleccionado] = useState({});
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState({});
  const [transportistaSeleccionada, setTransportistaSeleccionada] = useState(
    {}
  );
  const [tipoSeleccionado, setTipoSeleccionado] = useState({});
  const [duenioSeleccionado, setDuenioSeleccionado] = useState({});

  useEffect(() => {
    // CAMBIO A LA OBTENCION DE TIPO VEHICULOS
    // getData("/desplegables/tipovehiculos", setTipoVehiculo);

    // NUEVO OBTENER DESDE TABLA tipovehiculos
    // getData("/tipos_vehiculos/activos", setTipoVehiculo);
    getData("/tipos_vehiculos2/activos", setTipoVehiculo);
    //

    getData("/choferes", setChoferes);
    getData("/desplegables/usoVehiculo", setUso);
    getData("/sucursales", setSucursales);
    getData("/desplegables/dueniovehiculo", setduenio);
    getData("/transportistas", settransportistas);
  }, []);

  //Funcion para guardar vehiculos
  const guardarVehiculos = (e) => {
    // Al venir de un "form"
    if (e && typeof e.preventDefault === "function") e.preventDefault();

    setDisbtn(true);

    // Datos a guardar en Vehiculos
    const payloadVehiculo = {
      id_sisven: datosVehiculo.id_sisven,
      id_sisven_autogas:datosVehiculo.id_sisven_autogas,
      capacidad: datosVehiculo.capacidad,
      id_tipo: tipoSeleccionado?.id || null,
      activo: 1,
      id_chofer:
        tipoSeleccionado?.requiere_chofer === 0
          ? null
          : choferSeleccionado?.id || null,
      tara: datosVehiculo.tara,
      uso: usoSeleccionado.id,
      ltstkcombustible: datosVehiculo.ltstkcombustible,
      id_sucursal: sucursalSeleccionada.id,
      t1: datosVehiculo.t1,
      patente: datosVehiculo.patente,
      usuario: localStorage.getItem("user"),
      capacidadtotalm3: datosVehiculo.capacidadtotalm3,
      duenio: duenioSeleccionado.id,
      id_transportista: transportistaSeleccionada.id_transportista,
      id_modelo: modeloSeleccionado.id,
      nro_motor: datosVehiculo.nro_motor,
      nro_chasis: datosVehiculo.nro_chasis,
      uuid_vehiculo: uuid,
    };

    // Primer POST: /vehiculos
    postData(
      e,
      "/vehiculos",
      payloadVehiculo,
      (res1) => {
        // Éxito guardando vehículo -> armado de los vencimientos
        const vencimientosPayload = componentes.map((comp) => {
          const keyBase = comp.componente.toLowerCase().replace(/\s+/g, "_");
          const fieldName = `vencimiento_${keyBase}`;
          const rawFecha = datosVehiculo?.[fieldName] ?? null;
          const vencimiento = rawFecha
            ? moment(rawFecha).format("YYYY-MM-DD")
            : null;

          return {
            uuid_vehiculo: uuid,
            id_componente: comp.id_componente,
            vencimiento,
          };
        });

        console.log("componentes ANTES DE PAYLOAD:", componentes);

        const vencimientosToSend = vencimientosPayload.filter(
          (v) => v.vencimiento !== null
        );

        if (vencimientosToSend.length === 0) {
          // No hay vencimientos para guardar -> Informa y sale
          setNotificacion({
            tipo: "success",
            mensaje:
              "Vehículo guardado. No se detectaron vencimientos cargados para guardar.",
          });
          return;
        }

        // Segundo POST: /vehiculos_vencimientos
        postData(
          e,
          "/vehiculos_vencimientos",
          { vencimientos: vencimientosToSend },
          (res2) => {
            // Éxito guardando vencimientos -> dispara notificación success
            setNotificacion({
              tipo: "success",
              mensaje: "Vehículo y vencimientos guardados correctamente.",
            });
          },
          (err2) => {
            // Error al guardar vencimientos (snackbar en rojo, NO cierra el modal)
            setNotificacion({
              tipo: "error",
              mensaje:
                (err2 && err2.message) ||
                "Ocurrió un error al guardar los vencimientos. Verifique los datos y reintente.",
            });
            setDisbtn(false);
          }
        );
      },
      (err) => {
        // Error al guardar vehículo
        setNotificacion({
          tipo: "error",
          mensaje:
            (err && err.message) ||
            "Ocurrió un error al guardar el vehículo. Verifique los datos y reintente.",
        });
        setDisbtn(false);
        // no cierra modal
      }
    );
  };

  const almacenar = (e) => {
    const { name, value } = e.target;
    setDatosVehiculo((prev) => ({
      ...prev,
      [name]: value === "" ? null : value,
    }));
  };

  const handleClose = () => {
    return props.tabla(true), props.alta(false);
  };

  // *********************************************************************

  // Cuando el tipo seleccionado no requiera chofer, limpio el select
  useEffect(() => {
    if (tipoSeleccionado?.requiere_chofer === 0) {
      // limpia valor del "Autocomplete"
      setChoferSeleccionado(null);

      // Dejo el "id_chofer" en null
      setDatosVehiculo((prev) => ({
        ...prev,
        id_chofer: null,
      }));
    }
  }, [tipoSeleccionado]);

  // *********************************************************************

  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };

  useEffect(() => {
    setDatosVehiculo({ ...datosVehiculo, t1: 0 });
  }, [tipoSeleccionado, datosVehiculo.uso]);

  const [error, setError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");
  const [patenteRepetida, setPatenteRepetida] = useState(null);
  const [timeoutId, setTimeoutId] = useState(null);

  useEffect(() => {
    if (patenteRepetida && patenteRepetida[0]) {
      setError(true);
      setMensajeError("Patente Repetida");
      setDisbtn(true);
    } else {
      setError(false);
      setMensajeError("");
      setDisbtn(false);
    }
  }, [patenteRepetida]);

  // ********************************************************************

  const [componentes, setComponentes] = useState([]);

  const obtenerComponentes = () => {
    fetch(
      UrlApi + "/relacion_tiposv_componentes/activos/" + tipoSeleccionado.id
    )
      .then((data) => data.json())
      .then((data) => setComponentes(data));
  };

  useEffect(() => {
    obtenerComponentes();
  }, [tipoSeleccionado]);

  return (
    <>
      {tabla ? (
        <Container sx={{mWidth:"xl"}} disableGutters>
          {notificacion && notificacion.open ? (
            <Notify
              mensaje={notificacion.mensaje}
              open={notificacion.open}
              color={notificacion.color}
              handleClose={handleClose}
              severity={notificacion.severity}
            />
          ) : null}
          <Title titulo="Nuevo Vehículo" handleClose={handleClose} />
          <form onSubmit={guardarVehiculos} autoComplete="off">
            <Box
              mt={2}
              mb={3}
              p={2}
              border={0.5}
              borderRadius={4}
              backgroundColor="#F4F6F6"
              borderColor={"#ABB2B9"}
            >
              <Grid container spacing={1.2} style={{ padding: 6 }}>
                <Grid item xs={1.5}>
                  <TextField
                    placeholder="ID Hipergas"
                    required
                    focused
                    color="primary"
                    size="small"
                    style={style}
                    name="id_sisven"
                    label="ID Sisven Hipergas"
                    type="text"
                    value={datosVehiculo.id_sisven}
                    onChange={almacenar}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    inputProps={{
                      maxLength: 7,
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <MeetingRoomIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={1.5}>
                  <TextField
                    placeholder="ID Autogas"
                    required
                    focused
                    color="primary"
                    size="small"
                    style={style}
                    name="id_sisven_autogas"
                    label="ID Sisven Autogas"
                    type="text"
                    value={datosVehiculo.id_sisven_autogas}
                    onChange={almacenar}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    inputProps={{
                      maxLength: 7,
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <MeetingRoomIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                {/* AGREGADO DE MARCA Y MODELO */}
                <Grid item xs={3}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <Autocomplete
                      fullWidth
                      options={marcas || []}
                      loading={!marcas}
                      disabled={!marcas}
                      size="small"
                      disableClearable
                      autoHighlight
                      noOptionsText={"Marca INEXISTENTE"}
                      getOptionLabel={(m) => m.descripcion}
                      // value={marcaSeleccionada}
                      value={marcaSeleccionada || null}
                      onChange={(event, value) => setMarcaSeleccionada(value)}
                      renderInput={(params) => (
                        <TextField
                          style={style}
                          required
                          focused
                          size="small"
                          placeholder="Tipee para buscar..."
                          {...params}
                          label="Marca"
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                              <InputAdornment position="start">
                                <TimeToLeaveIcon />
                              </InputAdornment>
                            ),
                            endAdornment: (
                              <>
                                {!marcas ? (
                                  <CircularProgress size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }}
                        />
                      )}
                      renderOption={(props, option) => (
                        <Box
                          component="li"
                          key={option.id}
                          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                          {...props}
                        >
                          {option.descripcion}
                        </Box>
                      )}
                      sx={{ flexGrow: 1 }}
                    />
                    <Tooltip title="Agregar Marca">
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={handleClickMarca}
                      >
                        <AddBoxIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Grid>

                <Grid item xs={3}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    {Object.keys(marcaSeleccionada).length === 0 ? (
                      <TextField
                        disabled
                        focused
                        fullWidth
                        size="small"
                        label="Modelo"
                      />
                    ) : (
                      <Autocomplete
                        disabled={!modelos}
                        loading={!modelos}
                        options={modelos || []}
                        size="small"
                        noOptionsText="Modelo INEXISTENTE"
                        autoHighlight
                        loadingText="Buscando modelos..."
                        isOptionEqualToValue={(option, value) =>
                          option.id === value?.id
                        }
                        getOptionLabel={(m) => `${m.descripcion}`}
                        value={modeloSeleccionado || null}
                        onChange={(event, value) =>
                          setModeloSeleccionado(value)
                        }
                        renderOption={(props, option) => (
                          <Box
                            component="li"
                            key={option.id}
                            sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                            {...props}
                          >
                            {option.descripcion}
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            style={style}
                            required
                            focused
                            size="small"
                            placeholder="Tipee para buscar..."
                            {...params}
                            label="Modelo"
                          />
                        )}
                        sx={{ flexGrow: 1 }}
                      />
                    )}

                    <Tooltip title="Agregar Modelo">
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={handleClickModelo}
                      >
                        <AddBoxIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    placeholder="Patente"
                    required
                    focused
                    style={style}
                    size="small"
                    name="patente"
                    color="primary"
                    label="Patente"
                    value={datosVehiculo.patente}
                    error={error}
                    helperText={mensajeError}
                    inputProps={{ maxLength: 7 }}
                    onChange={(e) => {
                      const inputValue = e.target.value
                        .toUpperCase()
                        .replace(/\s/g, "");

                      // Validación de formato
                      const newFormat = /^[A-Z]{2}[0-9]{3}[A-Z]{2}$/; // AB123CD
                      const oldFormat = /^[A-Z]{3}[0-9]{3}$/; // ABC123

                      almacenar({
                        target: {
                          name: "patente",
                          value: inputValue,
                        },
                      });

                      if (
                        newFormat.test(inputValue) ||
                        oldFormat.test(inputValue)
                      ) {
                        setError(false);
                        setMensajeError("");

                        // Evitar múltiples llamadas: Limpiar timeout previo
                        if (timeoutId) clearTimeout(timeoutId);

                        // Retrasar la verificación de patente repetida
                        const newTimeoutId = setTimeout(() => {
                          getData(
                            `/vehiculos/patenterepetida/${inputValue}`,
                            setPatenteRepetida
                          );
                        }, 300); // 300 ms de espera
                        setTimeoutId(newTimeoutId);
                      } else {
                        setError(true);
                        setDisbtn(true);
                        setMensajeError("El formato debe ser AB123CD o ABC123");
                        if (timeoutId) clearTimeout(timeoutId); // Cancelar llamadas si el formato no es válido
                      }
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <EightteenMpIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    label="Capacidad Tanque Combustible (lts)"
                    color="primary"
                    focused
                    style={style}
                    size="small"
                    name="ltstkcombustible"
                    type="number"
                    value={datosVehiculo.ltstkcombustible}
                    onChange={almacenar}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">Lts</InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    placeholder="Capacidad (m3)"
                    focused
                    name="capacidadtotalm3"
                    label="Capacidad (M3)"
                    style={style}
                    color="primary"
                    size="small"
                    value={datosVehiculo.capacidadtotalm3}
                    onChange={(e) => {
                      setDatosVehiculo({
                        ...datosVehiculo,
                        capacidadtotalm3: e.target.value,
                        capacidad: e.target.value * 1000 * 0.52 * 0.85,
                      });
                    }}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    inputProps={{
                      maxLength: 2,
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Battery50Icon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    disabled
                    focused
                    name="capacidad"
                    label="Capacidad KG (85% llenado)"
                    style={style}
                    size="small"
                    color="primary"
                    value={datosVehiculo.capacidad}
                    onChange={almacenar}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Battery50Icon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    placeholder="Tara"
                    color="primary"
                    focused
                    style={style}
                    name="tara"
                    label="Tara"
                    type="number"
                    size="small"
                    value={datosVehiculo.tara}
                    onChange={almacenar}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <FactCheckIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Grid item xs={4}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    <Autocomplete
                      disabled={
                        !choferes || tipoSeleccionado.requiere_chofer === 0
                      }
                      disableClearable
                      size="small"
                      id="choferes"
                      noOptionsText="Chofer INEXISTENTE"
                      options={choferes || []}
                      loading={!choferes}
                      getOptionLabel={(chofer) => chofer?.nombre_apellido ?? ""}
                      value={choferSeleccionado || null}
                      autoHighlight
                      onChange={(event, value) => setChoferSeleccionado(value)}
                      renderInput={(params) => (
                        <TextField
                          style={style}
                          focused
                          size="small"
                          placeholder="Tipee para buscar..."
                          {...params}
                          label="Chofer"
                          inputProps={{
                            ...params.inputProps,
                            startAdornment: (
                              <InputAdornment position="start">
                                <TimeToLeaveIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                      renderOption={(props, option) => (
                        <Box
                          component="li"
                          key={option.id}
                          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                          {...props}
                        >
                          {option.nombre_apellido}
                        </Box>
                      )}
                      sx={{ flexGrow: 1 }}
                    />

                    <Tooltip title="Agregar Chofer">
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={handleClickchofer}
                      >
                        <AddBoxIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Grid>

                <Grid item xs={4}>
                  <Autocomplete
                    disabled={!uso}
                    loading={!uso}
                    options={uso || []}
                    size="small"
                    focused
                    disableClearable
                    id="uso"
                    noOptionsText={"Uso INEXISTENTE"}
                    autoHighlight
                    getOptionLabel={(uso) => uso.valor}
                    onChange={(event, value) => {
                      setUsoSeleccionado(value);
                    }}
                    renderInput={(params) => (
                      <TextField
                        style={style}
                        required
                        focused
                        size="small"
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Uso"
                        inputProps={{
                          ...params.inputProps,
                          endAdornment: (
                            <>
                              {!uso ? <CircularProgress size={20} /> : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.valor}
                      </Box>
                    )}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <TimeToLeaveIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Grid item xs={4}>
                  <Autocomplete
                    disabled={!sucursales}
                    loading={!sucursales}
                    options={sucursales || []}
                    focused
                    disableClearable
                    size="small"
                    id="sucursal"
                    noOptionsText={"Sucursal INEXISTENTE"}
                    autoHighlight
                    getOptionLabel={(sucursal) => sucursal.nombre}
                    onChange={(event, value) => {
                      setSucursalSeleccionada(value);
                    }}
                    renderInput={(params) => (
                      <TextField
                        style={style}
                        required
                        focused
                        size="small"
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Sucursal"
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.nombre}
                      </Box>
                    )}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <TimeToLeaveIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Grid item xs={3}>
                  <Autocomplete
                    disabled={!duenio}
                    loading={!duenio}
                    options={duenio || []}
                    focused
                    disableClearable
                    id="duenio"
                    size="small"
                    noOptionsText={"Dueño INEXISTENTE"}
                    autoHighlight
                    getOptionLabel={(duenio) => duenio.valor}
                    onChange={(event, value) => {
                      setDuenioSeleccionado(value);
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.valor}
                      </Box>
                    )}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <TimeToLeaveIcon />
                        </InputAdornment>
                      ),
                    }}
                    renderInput={(params) => (
                      <TextField
                        style={style}
                        required
                        focused
                        size="small"
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Dueño"
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={3}>
                  <Autocomplete
                    disabled={!transportistas}
                    loading={!transportistas}
                    options={transportistas || []}
                    size="small"
                    focused
                    disableClearable
                    id="transportista"
                    noOptionsText={"Transportista INEXISTENTE"}
                    autoHighlight
                    getOptionLabel={(transportista) => transportista.nombre}
                    onChange={(event, value) => {
                      setTransportistaSeleccionada(value);
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.nombre}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        style={style}
                        required
                        focused
                        size="small"
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Transportista"
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {!transportistas ? (
                                <CircularProgress size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                    sx={{ flexGrow: 1 }}
                  />
                </Grid>

                <Grid item xs={3}>
                  <Autocomplete
                    disabled={!tipoVehiculo || tipoVehiculo.length === 0}
                    options={tipoVehiculo || []}
                    loading={tipoVehiculo || []}
                    size="small"
                    focused
                    disableClearable
                    id="tipoVehiculo"
                    noOptionsText={"Tipo INEXISTENTE"}
                    getOptionLabel={(tipo) => tipo?.nombre ?? ""}
                    autoHighlight
                    value={tipoSeleccionado || null}
                    onChange={(event, value) => {
                      setTipoSeleccionado(value);
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.nombre}
                      </Box>
                    )}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <TimeToLeaveIcon />
                        </InputAdornment>
                      ),
                    }}
                    renderInput={(params) => (
                      <TextField
                        style={style}
                        required
                        focused
                        size="small"
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Tipo"
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={1.5}>
                  <FormControlLabel
                    disabled={
                      !(
                        tipoSeleccionado &&
                        usoSeleccionado &&
                        tipoSeleccionado.es_t1 === 1 &&
                        usoSeleccionado.id === 66
                      )
                    }
                    checked={datosVehiculo.t1 === 1}
                    onChange={(e) =>
                      setDatosVehiculo({
                        ...datosVehiculo,
                        ["t1"]: e.target.checked ? 1 : 0,
                      })
                    }
                    control={
                      <Checkbox
                        sx={{
                          transform: "scale(1.25)",
                          position: "relative",
                          zIndex: 1,
                        }}
                      />
                    }
                    label="Es T1"
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    placeholder="N° Motor"
                    color="primary"
                    focused
                    size="small"
                    style={style}
                    name="nro_motor"
                    label="N° Motor"
                    type="text"
                    value={datosVehiculo.nro_motor}
                    onChange={almacenar}
                    inputProps={{
                      maxLength: 40,
                    }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <TextField
                    placeholder="N° Chasis"
                    color="primary"
                    focused
                    size="small"
                    style={style}
                    name="nro_chasis"
                    label="N° Chasis"
                    type="text"
                    value={datosVehiculo.nro_chasis}
                    onChange={almacenar}
                    inputProps={{
                      maxLength: 40,
                    }}
                  />
                </Grid>
              </Grid>

              <fieldset
                style={{
                  border: "1px solid #1976d2",
                  borderRadius: "8px",
                  padding: "16px",
                }}
              >
                <legend
                  style={{
                    padding: "0 8px",
                    fontWeight: "bold",
                    color: "#1976d2",
                  }}
                >
                  VENCIMIENTOS
                </legend>

                {/* MAPEO */}
                <Grid container spacing={2}>
                  {componentes.length > 0 ? (
                    componentes.map((comp) => {
                      const keyBase = comp.componente
                        .toLowerCase()
                        .replace(/\s+/g, "_");
                      const fieldName = `vencimiento_${keyBase}`;
                      const fieldValue = datosVehiculo?.[fieldName]
                        ? moment(datosVehiculo[fieldName]).format("YYYY-MM-DD")
                        : "";

                      return (
                        <Grid item xs={12} sm={4} key={comp.id}>
                          <Box
                            sx={{
                              backgroundColor: "#ffffffcc",
                              borderRadius: 2,
                              p: 2,
                              boxShadow: 1,
                            }}
                          >
                            <Typography
                              variant="subtitle1"
                              gutterBottom
                              sx={{ marginTop: -1, color: "#1976D2" }}
                            >
                              <b>{comp.componente}</b>
                            </Typography>

                            <Grid container direction="column" spacing={2}>
                              <Grid item>
                                <TextField
                                  fullWidth
                                  size="small"
                                  focused
                                  color="primary"
                                  label="Fecha Vto."
                                  name={fieldName}
                                  type="date"
                                  onChange={almacenar}
                                  value={fieldValue}
                                  InputLabelProps={{ shrink: true }}
                                  inputProps={{
                                    min: new Date().toISOString().split("T")[0], // fecha mínima: hoy
                                  }}
                                />
                              </Grid>
                            </Grid>
                          </Box>
                        </Grid>
                      );
                    })
                  ) : (
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          backgroundColor: "#ffffffcc",
                          borderRadius: 2,
                          p: 2,
                          boxShadow: 1,
                          textAlign: "center",
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          sx={{ color: "#1976D2" }}
                        >
                          <b>Sin Componentes</b>
                        </Typography>
                      </Box>
                    </Grid>
                  )}
                </Grid>
              </fieldset>

              <Grid
                mt={2}
                container
                direction="row"
                justifyContent="space-between"
                alignItemns="center"
              >
                <Button variant="contained" onClick={handleClose} color="error">
                  Volver
                </Button>
                <Button
                  variant="contained"
                  disabled={disBtn}
                  type="submit"
                  color="success"
                >
                  Guardar Vehiculo
                </Button>
              </Grid>
            </Box>
          </form>
          <br />
        </Container>
      ) : null}

      {altaMarca ? (
        <AddMarcaVehiculo alta={setAltaMarca} tabla={setTabla} />
      ) : null}

      {altaModelo ? (
        <AddModeloVehiculo alta={setAltaModelo} tabla={setTabla} />
      ) : null}

      {altachofer ? (
        <Addchofer
          alta={setAltachofer}
          tabla={setTabla}
          setActualizar={setActualizar}
        />
      ) : null}

      {/* Notificación al Guardar */}
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={autoHide}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity={severity}
            sx={{ width: "100%" }}
            style={{
              backgroundColor: colormensaje,
              color: severity === "error" ? "#6b0b14" : "#000",
              fontWeight: 500,
            }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default Addvehiculos;
